import IconifyIcon from './IconifyIcon';
import { Suspense, useState, useCallback } from 'react';
import ActivityStreamToggle from './header/ActivityStreamToggle';
import LeftSideBarToggle from './header/LeftSideBarToggle';
import Notifications from './header/Notifications';
import ProfileDropdown from './header/ProfileDropdown';
import ThemeCustomizerToggle from './header/ThemeCustomizerToggle';
import '../styles/header.scss';

const Header = ({ toggleSidebar }) => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleDropdownToggle = useCallback((dropdownName, isOpen) => {
    if (isOpen) {
      setActiveDropdown(dropdownName);
    } else if (activeDropdown === dropdownName) {
      setActiveDropdown(null);
    }
  }, [activeDropdown]);

  const closeAllDropdowns = useCallback(() => {
    setActiveDropdown(null);
  }, []);

  return (
    <header className="topbar">
      <div className="container-fluid">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <LeftSideBarToggle toggleSidebar={toggleSidebar} />
          </div>
          <div className="d-flex align-items-center" style={{ flexWrap: 'nowrap', gap: '0.5rem' }}>
            <Suspense>
              <Notifications 
                isOpen={activeDropdown === 'notifications'}
                onToggle={(isOpen) => handleDropdownToggle('notifications', isOpen)}
                onClose={closeAllDropdowns}
              />
            </Suspense>

            <ThemeCustomizerToggle />

            <ActivityStreamToggle />

            <ProfileDropdown 
              isOpen={activeDropdown === 'profile'}
              onToggle={(isOpen) => handleDropdownToggle('profile', isOpen)}
              onClose={closeAllDropdowns}
            />
            <form className="app-search d-none d-md-block ms-2">
              <div className="position-relative">
                <input type="search" className="form-control" placeholder="Search..." autoComplete="off" />
                <IconifyIcon icon="solar:magnifer-linear" className="search-widget-icon" />
              </div>
            </form>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
